export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/footer-bg-6a80c6928fb35625ac021711ddb5c21f.png";